import axios from 'axios';

export default {
  FETCH_GREETINGS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('banners/getAllBanners')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('greetings', JSON.stringify(payload));
                    commit('SET_GREETINGS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDGREETING ({ commit }, greetingId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`banners/getAllBanners`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedGreeting = payload.filter(x => {
              return x.bannerId.toString() === greetingId.toString()
            });

            console.log('found banner', selectedGreeting)
            commit('SET_SELECTED_GREETING', selectedGreeting[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_GREETING({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add Greeting payload : ", payload);
            axios.post('banners/addBanner', payload)
                .then((response) => {
                    console.log('ADD_TESTIMONIAL action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_TESTIMONIAL action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_GREETING({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/banners/updateBanner', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_TESTIMONIAL action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_GREETINGS_ORDERING ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.put(`banners/updBannerDispOrder`, payload).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        console.log('UPDATE_EXPERT response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('UPDATE_EXPERT error ', error);
        reject(error);
      })
    })

  },
}



// WEBPACK FOOTER //
// ./src/store/modules/greetings/actions.js